import { useEffect, useRef, useState } from "react";

import "./marquii.css"

const Marquii = ({ title, id = "marquii", overlay = null, speed = 10, children }) => {
   const [vwWidth, setVwWidth] = useState();
   const marquiiElement = useRef();

   useEffect(() => {
      marquiiElement.current = document.getElementById(id);
      setVwWidth(window.innerWidth);
      const timerId = setTimeout(() => {
         startAnimation()
      }, 500);
      window.addEventListener("resize", () => setVwWidth(window.innerWidth));
      return () => {
         clearTimeout(timerId);
         window.removeEventListener("resize", () => vwWidth.current = window.innerWidth);
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [vwWidth])

   const startAnimation = () => {
      let slidesWidth = parseInt(marquiiElement.current.children[0].getBoundingClientRect().width);
      speed += (vwWidth / slidesWidth) / 10;
      let duration = Number(((vwWidth / speed) / 5) + ((vwWidth / speed) / 4) * 1000) //ms
      marquiiElement.current.children[0].style.animationDelay = Math.round((-duration / 1000 / 2)) + 's';
      marquiiElement.current.children[0].animate(
         {
            left: ["100%", `-${slidesWidth}px`],
            opacity: [0, 1, 1, 1, 1, 1, 1, 1, 0]
         },
         {
            duration,
            iterations: Infinity
         }
      )
   }
   const pauseAnim = () => {
      // !not working
      console.log(marquiiElement.current.children[0]);
      marquiiElement.current.children[0].style.animationPlayState = "paused";
      marquiiElement.current.style.animationPlayState = "paused";
   }

   // onMouseOver={(e) => console.log(e)}
   return (
      <div className="marquii-box" title={title} id={id} onClick={pauseAnim} aria-hidden>
         <div className="marquii-child" id={id + "-slides"}>
            {children}
         </div>
         <div className="marquii-overlay">
            {overlay}
         </div>
      </div >
   );
};

export default Marquii